import config from '../config'
import client from './client'

const endpoint = 'admin/mailup'

const getCredentials = () => {
  return client.get(config.serverUrl + endpoint)
}

const saveCredentials = (data) => {
  return client.put(config.serverUrl + endpoint, data)
}

export default {
  getCredentials,
  saveCredentials,
}
